export default [
    {
        value: 'number',
        label:'number'
    },
    {
        value: 'text',
        label:'text'
    },
    {
        value: 'date',
        label:'date'
    }
]